export default "__VITE_ASSET___kTU5zRI__"